/* unplugin-vue-components disabled */import script from "./mg-flex.vue?vue&type=script&setup=true&lang=js"
export * from "./mg-flex.vue?vue&type=script&setup=true&lang=js"

import "./mg-flex.vue?vue&type=style&index=0&id=64fc58db&lang=less"

const __exports__ = script;

export default __exports__